<template>
  <div class="tr-main">
    <intHtQueryCard @queryHtCn="queryHtCn" @chooseCcsqd="chooseCcsqd"></intHtQueryCard>
    <el-container>
      <el-main class="center-main">
        <div class="filter all-container">
          <h3>筛选</h3>
          <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="价格/星级" name="0">
              <span slot="label"
                :class="{ spot: (htCnSonTags.start.length || htCnSonTags.input.length) > 0 ? true : false }"></span>
              <span slot="label">价格/星级</span>
              <ht-start ref="start" @getInputObj="getInputObj" @changeList="changeList"
                @removeAll="removeAll"></ht-start>
            </el-tab-pane>
            <!-- <el-tab-pane>
              <span slot="label"
                :class="{ spot: (htCnSonTags.hotel.length || htCnSonTags.services.length) > 0 ? true : false }"></span>
              <span slot="label">更多筛选</span>
              <el-button round v-if="tripType == 1" :class="{ clickbtn: travelStandardsFilter }"
                @click="changetravelStandardsFilter()">
                符合差标
              </el-button>
            </el-tab-pane> -->
          </el-tabs>
        </div>
        <div class="bottom all-container">
          <div class="bottom-left">
            <div class="bottom-left-top">
              <h2 v-if="htCnParams.cityId && searchList.list">找到{{ searchList.total }}家</h2>
              <h2 v-if="htCnParams.cityId">酒店</h2>
              <div class="search-list">
                <el-tag v-for="tag in tagList" :key="tag.name" closable size="medium" effect="dark"
                  @close="closeTag(tag)">
                  {{ tag.name }}
                </el-tag>
                <span class="removeAll" v-if="tagList.length" @click="removeAll">全部清除</span>
              </div>
              <div class="search-title">
              </div>
            </div>
            <div calss="bottom-left-bottom">
              <intHtList class="bottom-left-bottom" :searchList="searchList" :loading="htLoading"
                @getMapAddress="getMapAddress" @jumpDetails="jumpDetails" />
              <el-pagination v-if="searchList.total" @current-change="handleCurrentChange" background
                layout="prev, pager, next" :total="searchList.total" :current-page="htCnParams.pageNum"></el-pagination>
            </div>
          </div>
          <div class="bottom-right">
            <template v-if="tripType != 2">
              <div class="ccsqdPe"
                v-if="JSON.stringify(policy) != '{}' && ((bookStyle == 2 && gkfsRole == 2 && tripType == 1) || (bookStyle == 1 && tripType == 1))">
                <p>差旅标准</p>
                <div class="clbz-clbzText">
                  <span>{{ policy.mulPerson == 1 ? '已开启' : '未开启' }}多人差标模式</span>
                </div>
                <div class="clbz-user" v-show="policy.mulPerson != 1">
                  本次预订采用<span style="opacity: 1;color: #4089FF;">{{ useNameclbz }}</span>的差旅标准
                </div>
                <div class="clbz-user" v-show="policy.mulPerson == 1">
                  本次预订采用<span style="opacity: 1;color: #4089FF;">入住人{{ policy.mulPersonStandardDesc }}</span>的差旅标准
                </div>
                <span class="f12" v-if="jdjgbz != void 0">酒店订房 不超过 <span
                    style="color: red; font-size: 14px;font-weight: 400;">{{
                      jdjgbz }}{{ policy.currency || '元'
                    }}</span>/间</span>
              </div>
              <!-- 申请单管控 -->
              <div class="ccsqdPe" v-if="bookStyle == 2 && gkfsRole == 1 && tripType == 1">
                <span>本次预算金额</span>
                <span style="padding: 0 1px;color:#4089FF;">{{ fyys }}</span>
                <span>的差旅标准</span>
              </div>
            </template>
            <template v-if="tripType == 2">
              <div class="ccsqdPe" slot="reference">当前预算未管控</div>
            </template>
            <!-- <ht-cn-amap :class="{ mapFixed: fixed }" @windowsClick="windowsClick" :zoomInAndOut="zoomInAndOut"
              :mapType="mapType" :currentMap="currentMap" :searchList="searchList"></ht-cn-amap> -->
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {
  mapGetters, mapMutations, mapState
} from 'vuex'
import mixin from './../../mixin'
import hotelmixin from './../../mixin/models/hotelMixin.js'
import intHtList from './components/intHtList.vue'
import intHtQueryCard from './components/intHtQueryCard'
import htStart from './components/intHtStar.vue'
import { establishmentDateStr, getScoreDesc } from '../../hooks/useHotel.js'

export default {
  created() { },
  mounted() {
    // 首页跳转搜索一下
    let isHome = this.$route.query.home;
    if (isHome) {
      this.searchAll()
    }
    this.initRulers()
    window.onscroll = () => {
      let top = this.getScrollTop()
      if (top > 496) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    }

  },
  components: {
    htStart,
    intHtList,
    // 'ht-cn-amap': htCnAmap,
    intHtQueryCard
  },
  mixins: [mixin.ccsqdMixin, hotelmixin.hotelCxrListCtrl],
  data() {
    // 限制数量（小于才加载分屏）
    this.minSecondLength = 8;
    return {
      cityId: '',
      mapType: 1,
      fyys: '',
      htLoading: false,
      searchList: {},
      tagList: [],
      activeName: '',
      sortModel: '',
      fixed: false, // 地图定位
      zoomInAndOut: false, //点击文案地图放大缩小
      currentMap: {}, //点击列表获取当前酒店新增地址 及 坐标定位
      sortOptions: [
        //sort排序
        {
          name: '默认排序',
          value: ''
        },
        {
          name: '星级从高到低',
          value: 22
        },
        {
          name: '星级从低到高',
          value: 21
        },
        {
          name: '价格从低到高',
          value: 31
        },
        {
          name: '价格从高到低',
          value: 32
        },
      ],
      travelStandardsFilter: false,
    }
  },
  watch: {
    searchList: {
      handler(val) {
        if (!val.list || val.list.length == 0) {
          // 数据为空的时候重置页码
          this.SET_HTCN_PARAMS({
            pageNum: 1,
          })
        }
      },
    },
    htCnSonTags: {
      handler(val) {
        this.tagList = []
        for (let key in val) {
          val[key].forEach((element) => {
            this.tagList.push(element)
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      htCnQuery: (state) => state.intHt.htCnQuery, //
      htCnCcsqD: (state) => state.intHt.htCnCcsqD,
      ccsqdInfo: (state) => state.common.ccsqdInfo, // 出差申请单信息
      htCnParams: (state) => state.intHt.htCnParams,
      htCnSonTags: (state) => state.intHt.htCnSonTags,
      htCnPolicy: (state) => state.intHt.htCnPolicy,
      cxrList: state => state.intHt.cxrList, // 出行人
      rooms: state => state.intHt.rooms,
    }),
    ...mapGetters({
      getVipParamterByParNo: 'common/getVipParamterByParNo',
      useNameclbz: 'intHt/getUseNameclbz',
    }),
    // 日期最小，和最大值对象
    bookDateRange() {
      // 方法来自于mixins
      let dateRangeObj = this.getBookDateRange(10903, this.htCnQuery.tripType, 365, this.htCnCcsqD.ccsqdId, this.htCnCcsqD.routeId);

      return dateRangeObj
    },
    ccr() {
      return this.htCnCcsqD.detail.ccr
    },
    jdjgbz() {
      return this.htCnPolicy?.policy?.jdjgbz ?? '0'
    },
    policy() {
      return this.htCnPolicy?.policy ?? {}
    },
    tripType() {
      /* 默认当前因公因私*/
      return this.htCnQuery.tripType //1为公 2为私
    },
    gkfsRole() {
      return this.htCnQuery.gkfsRole
    },
    // fyys() {
    // 	return this.htCnCcsqD?.currentRoute?.fyys??''
    // },
    userInfo() {
      let user = this.$common.getUserInfo() || {};
      return user
    },
    vipCorp() {
      return this.userInfo.vipCorp || {};
    },
    bookStyle() {
      // 1单订模式  2出差申请单模式
      return this.$common.getBookStyle(this.$store, 10903) || this.vipCorp.bookStyle
    },
    //因公因私参数控制
    vipParams() {
      /**
       *   t系统   1因私开启 2因公开启
       *   et  1因公开启，2因私开启  这里做一下换
       */
      let params = this.getVipParamterByParNo(20009, 3)
      return params //  与t系统参数相反 //this.$common.getVipParams('20011',3);  火车票因公 ， 因私 开启
    },

  },


  methods: {
    ...mapMutations({
      SET_HTCN_QUERY: 'intHt/SET_HTCN_QUERY', // 保存因共模式下的自定义信息
      SET_HTCN_PARAMS: 'intHt/SET_HTCN_PARAMS', // 设置查询参数
      SET_HTCN_CCSQD: 'intHt/SET_HTCN_CCSQD', //保存因共模式下的出差申请单信息
      SET_CCSQD_INFO: 'common/setCcsqdInfo', // 全局的出差申请单信息
      SET_HTCN_SONNTAGS: 'intHt/SET_HTCN_SONNTAGS',
      SAVE_HOTELINFO: 'intHt/SAVE_HOTELINFO',
    }),
    windowsClick(item) {
      let itemInfo = this.searchList.list.filter((i) => i.jdid == item)
      this.jumpDetails(itemInfo[0])
    },
    chooseCcsqd(value) {
      this.fyys = value?.currentRoute?.fyys ?? ''
    },
    // 获取滚动条到顶部距离
    getScrollTop() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    getInputObj() {
      this.searchAll(true)
    },
    handleCurrentChange(val) {
      // this.htCnParams.pageNum=val
      this.SET_HTCN_PARAMS({
        pageNum: val,
      })
      this.searchAll()
    },
    changeList() {
      this.searchAll(true)
    },
    // 符合差标
    changetravelStandardsFilter() {
      this.travelStandardsFilter = !this.travelStandardsFilter;

      this.searchAll(true)
    },
    jumpDetails(item) {
      item.checkInDate = this.htCnParams.checkInDate
      item.checkOutDate = this.htCnParams.checkOutDate
      let hotelItem = {
        checkInDate: this.htCnParams.checkInDate,
        checkOutDate: this.htCnParams.checkOutDate,
        jdid: item.jdid,
        cityId: this.htCnParams.cityId
      }
      this.SAVE_HOTELINFO(item)
      let routeUrl = this.$router.resolve({
        name: 'HtCnDetails',
        query: hotelItem,
      })
      window.open(routeUrl.href, '_blank')
    },
    // 地图位置
    getMapAddress(item) {
      this.zoomInAndOut = this.zoomInAndOut ? false : true;
      this.currentMap = item;
    },
    // 查询酒店
    queryHtCn(isClear = false) {
      this.searchAll(isClear)
    },
    sortChange() {
      // 排序
      this.SET_HTCN_PARAMS({
        sort: this.sortModel
      })
      this.searchAll(true)
    },
    closeTag(val) {
      // 关闭单个tages
      if (val.fitlerTypeByOne == 'start') {
        let index = this.$refs.start.startList.indexOf(val)
        this.$refs.start.startList[index].bOn = false
      } else if (val.fitlerTypeByOne == 'input') {
        this.$refs.start.form.min = ''
        this.$refs.start.form.max = ''
        this.$refs.start.priceBlur()
      } else if (val.fitlerTypeByOne == 'hotel') {
        this.$refs.hotel.removeHotel(val)
      } else if (val.fitlerTypeByOne == 'services') {
        this.$refs.hotel.removeServices(val)
      }
    },
    removeAll() {
      this.tagList = []
      // this.$refs.hotel.removeAll()
      this.SET_HTCN_SONNTAGS({
        start: [],
        input: [],
        hotel: [],
        services: [],
      })
      this.SET_HTCN_PARAMS({
        starRate: '',
        priceRange: '',
        propertyIds: '',
        brandIds: '',
      })
      // 清除数据
      this.searchAll(true)
    },
    initRulers() {
      // 初始化的时候就把管控规则存入vux里面
      // 出差审请单模式
      if (this.bookStyle == 2) {
        //1单订模式  2出差申请单模式

      } else {
        // this.getClbz();
      }
    },

    handleClick(tab, event) {
      if (tab.index == this.activeName) {
        // this.spotShow = true
      }
    },
    judgeQueryParam() {
      let htCnParams = this.htCnParams;
      if (!htCnParams.cityId) {
        this.$message({
          type: 'error',
          message: '请先输入城市',
        })
        return;
      }
      if (!htCnParams.checkInDate || !htCnParams.checkOutDate) {
        this.$message({
          type: 'error',
          message: '请先输入日期',
        })
        return;
      }

      // 校验房间数量，每间房必须相同人数
      if (this.rooms && this.rooms.length > 0 && this.tripType == 1) {
        const firstValidCount = this.htCnParams.adultNum || 1;
        const mismatchedRooms = this.rooms.filter(rc => rc.length !== firstValidCount);
        if (mismatchedRooms.length !== 0) {
          this.$confirm('国际酒店下单必须保证每个房间人数相同，如需房间不同人数请分开下单！', '温馨提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          })
          return;
        }
      }

      let params = {
        cityId: htCnParams.cityId, //城市或者商圈id
        checkInDate: htCnParams.checkInDate, //日期开始时间
        checkOutDate: htCnParams.checkOutDate, // 日期结束时间
        keyword: htCnParams.keywords, //关键字
        lat: htCnParams.lat,
        lon: htCnParams.lon,
        sort: htCnParams.sort, //排序
        jdType: htCnParams.jdType, //是否是协议
        pageNum: htCnParams.pageNum, //当前页数，不能小于1 ,
        propertyIds: htCnParams.propertyIds, //服务设施id，多个以逗号隔开 ,
        priceRange: htCnParams.priceRange, //价格范围：不传代表不限；范围以-隔开；如果是150元以下，传0-150；如果是800元以上，传800-999999 ,
        star: htCnParams.starRate, //挂牌星级：不限就不传；二星级以下,传2；三星传3A；以此类推,多个以英文逗号隔开 ,
        count: 10,
        tripType: this.tripType,
      }
      if (this.travelStandardsFilter && this.tripType == 1) {
        params.travelStandardsFilter = this.travelStandardsFilter ? 1 : 0;
        let clbzObj = this.getClbzParamMap();
        params = {
          ...params,
          ...clbzObj
        }
        params.ccsqdId = this.htCnCcsqD.ccsqdId;
        params.routeId = this.htCnCcsqD.routeId;
      }
      return params;
    },
    searchAll(isClear = false) {
      if (!!isClear) {
        this.SET_HTCN_PARAMS({
          pageNum: 1,
        })
      }
      let params = this.judgeQueryParam()
      if (!params) return;
      this.htLoading = true

      this.$conn.getConn('intht.interHotelListSearch')(params).then((res) => {
        if ((res.httpStatus = 200)) {
          let data = res.data || {};
          let pageInfo = data.pageInfo || {};
          this.htLoading = false;

          pageInfo.list = (pageInfo.list || []).map(item => {
            return {
              ...item,
              scoreDesc: getScoreDesc(item.reviewCommonScore || 5),
              establishmentDateDesc: establishmentDateStr(item.establishmentDate),
            }
          })
          this.searchList = pageInfo;
        }
      })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tips,
          })
          this.htLoading = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
.f12 {
  font-size: 14px;
  font-weight: 400;
}

.clickbtn {
  border: 1px solid #007aff;
  background-color: #007aff;
  color: #fff;

}

.clickbtn.el-button:focus,
.clickbtn.el-button:hover {
  color: #fff;
  border: 1px solid #007aff;
  background-color: #007aff;
}

.tr-main {
  width: 100%;
  margin: 0 auto;
  min-height: 860px;
  font-family: '微软雅黑';

  .all-container {
    width: 1200px;
    margin: 0 auto;
  }

  .center-main {
    height: 100%;
    min-height: 860px;
    background-color: #eef1f6;

    .bottom {
      background-color: white;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      background-color: #eef1f6;

      .bottom-left {
        width: 860px;

        .bottom-left-top {
          background-color: #fff;
          box-sizing: border-box;
          padding: 16px 16px 16px 24px;
          display: flex;

          h2 {
            margin-top: 5px;
          }

          .search-list {
            flex: 1;
            margin-left: 24px;
            display: flex;
            width: 300px;
            flex-wrap: wrap;
            align-items: center;

            .el-tag--medium {
              margin-right: 10px;
              margin-top: 10px;
            }

            .removeAll {
              color: #007aff;
              font-size: 12px;
              margin-left: 20px;
              margin-top: 10px;
            }
          }

          .search-title {
            margin-top: 5px;
            margin-right: 5px;

            /deep/ .el-input__inner {
              border: 0;
              width: 126px;
              //  color: red;
            }
          }
        }
      }

      .bottom-right {
        background-color: #eef1f6;
        flex: 1;
        margin-left: 20px;
        height: 400px;

        .mapFixed {
          position: fixed;
          top: 0;
          width: 320px;
          height: 400px;
        }

        .ccsqdPe {
          text-align: left;
          width: 100%;
          min-height: 69px;
          background-color: #fff;
          margin-bottom: 20px;
          box-sizing: border-box;
          // cursor: pointer;
          padding: 20px 20px;

          p {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 15px;
          }

          span {
            font-size: 15px;
            font-weight: bold;
            color: #424242;
            // line-height: 69px;
          }

          // }
        }
      }
    }
  }

  .tr-main-header {
    display: flex;
    justify-content: flex-start;
    // padding-top: 20px;
    height: 70px;

    .el-input {
      width: 200px;
      margin-left: 20px;
    }

    .tr-input {
      line-height: 70px;

      /deep/ .el-input__inner {
        width: 200px;
        height: 34px;
        line-height: 34px;
      }
    }
  }

  .bgWhite {
    background-color: #ffffff;
  }

  .filter {
    display: flex;
    justify-content: space-between;
    background-color: white;
    margin-top: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 6px;

    h3 {
      margin: 10px;
    }

    .tabs {
      flex: 1;
    }

    .spot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 5px;
      background: #007aff;
    }

    /deep/ .el-tabs__item {
      display: flex;
      align-items: center;
    }

    /deep/ .el-tabs__nav {
      display: flex;
    }

    /deep/ .el-tab-pane {
      display: flex;
      align-items: center;
    }
  }
}
</style>
